import React from "react";
import { ChipsPopup } from "./ChipsPopup";
import { calc } from "../../../js/chips-common";
import "../../../assets/fonts/font.css";
export function WinnersPopup(props) {
  ChipsPopup(
    props,
    <div
      style={{
        display: "flex",
        flexDirection: "column",
      }}
    >
      <div
        style={{
          width: calc(200),
          marginTop: calc(16),
          padding: `0 ${calc(16)}`,
          color: "#3D3D3D",
          textAlign: "center",
          fontFamily: "Spoqa Han Sans Neo",
          fontSize: calc(18),
          fontStyle: "normal",
          fontWeight: "700",
          lineHeight: "150%",
          flex: "1 0 0",
        }}
      >
        당첨자 내역
        <div
          style={{
            color: "#888",
            textAlign: "center",
            fontFamily: "Spoqa Han Sans Neo",
            fontSize: calc(12),
            fontStyle: "normal",
            fontWeight: "400",
            lineHeight: "150%",
          }}
        >
          당첨을 축하드립니다!
        </div>
      </div>

      <div
        style={{
          position: "absolute",
          top: calc(12),
          right: calc(8),
          padding: calc(8),
          cursor: "pointer",
        }}
        onClick={() => {
          if (!props.close || !props.close()) {
            props.dismiss();
          }
        }}
      >
        <img
          style={{
            width: calc(20),
            height: calc(20),
          }}
          src="/games/fruits/assets/ic-title-back.png"
        />
      </div>

      <div
        className="scrollbar-hidden"
        onTouchMove={(event) => {
          event.stopPropagation();
        }}
        style={{
          width: "100%",
          maxHeight: `calc(min(${calc(387)}, 100vh - ${calc(
            80 + 65 + 16 + 50,
          )}))`,
          overflow: "scroll",
          position: "relative",
        }}
      >
        {props.data &&
        props.data.winning_histories &&
        props.data.winning_histories.length > 0 ? (
          <Winners histories={props.data.winning_histories} />
        ) : (
          <div
            style={{
              height: "100%",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              position: "absolute",
              gap: calc(4),
            }}
          >
            <span
              style={{
                color: "#212121",
                textAlign: "center",
                fontFamily: "Spoqa Han Sans Neo",
                fontSize: calc(14),
                fontStyle: "normal",
                fontWeight: "700",
                lineHeight: "142.857%",
                letterSpacing: "-0.2px",
              }}
            >
              당첨자 뽑는 중
            </span>
            <span
              style={{
                color: "#888",
                textAlign: "center",
                fontFamily: "Spoqa Han Sans Neo",
                fontSize: calc(12),
                fontStyle: "normal",
                fontWeight: "400",
                lineHeight: "150%",
                letterSpacing: "-0.2px",
              }}
            >
              곧 발표되니 조금만 기다려주세요.
            </span>
          </div>
        )}
      </div>
    </div>,
  );
}

function Winners({ histories }) {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        width: calc(240),
        marginTop: calc(12),
      }}
    >
      {histories.map((history) => (
        <div
          style={{
            width: "100%",
            display: "flex",
            flexDirection: "column",
            gap: calc(6),
            marginBottom: calc(16),
          }}
        >
          <span
            style={{
              width: "100%",
              color: "#212121",
              textAlign: "start",
              fontFamily: "Spoqa Han Sans Neo",
              fontSize: calc(14),
              fontStyle: "normal",
              fontWeight: "700",
              lineHeight: "150%",
              wordBreak: "keep-all",
            }}
          >
            {history.title}
          </span>

          {history.winning_prizes.map((prize) => (
            <div
              style={{
                display: "flex",
                padding: calc(10),
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "flex-start",
                gap: calc(8),
                alignSelf: "stretch",
                borderRadius: calc(7),
                background: "#F5F5F5",
              }}
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                  alignItems: "flex-start",
                  alignSelf: "stretch",
                  gap: calc(8),
                }}
              >
                <span
                  style={{
                    color: "#212121",
                    textAlign: "start",
                    fontFamily: "Spoqa Han Sans Neo",
                    fontSize: calc(12),
                    fontStyle: "normal",
                    fontWeight: "700",
                    lineHeight: "150%",
                  }}
                >
                  {prize.name}
                </span>
                <span
                  style={{
                    color: "#888",
                    textAlign: "center",
                    fontFamily: "Spoqa Han Sans Neo",
                    fontSize: calc(12),
                    fontStyle: "normal",
                    fontWeight: "400",
                    lineHeight: "150%",
                  }}
                >
                  {prize.duration}
                </span>
              </div>

              <div
                style={{
                  display: "flex",
                  padding: `${calc(8)} ${calc(10)}`,
                  flexDirection: "column",
                  alignItems: "center",
                  gap: calc(4),
                  alignSelf: "stretch",
                  borderRadius: calc(5),
                  background: "#FFFFFF",
                }}
              >
                <span
                  style={{
                    color: "#888",
                    textAlign: "center",
                    fontFamily: "Spoqa Han Sans Neo",
                    fontSize: calc(12),
                    fontStyle: "normal",
                    fontWeight: "400",
                    lineHeight: "150%",
                  }}
                >
                  닉네임(전화번호 뒷자리)
                </span>
                {prize.winners.map((winner) => (
                  <span
                    style={{
                      color: "#FF8A00",
                      textAlign: "center",
                      fontFamily: "Spoqa Han Sans Neo",
                      fontSize: calc(12),
                      fontStyle: "normal",
                      fontWeight: "700",
                      lineHeight: "150%",
                    }}
                  >
                    {winner}
                  </span>
                ))}
              </div>
            </div>
          ))}
        </div>
      ))}
    </div>
  );
}
